import { createAction } from '@reduxjs/toolkit'

import * as constants from './constants';

export const load = createAction<any>(constants.LOAD);
export const save = createAction<any>(constants.SAVE);
